import { render, staticRenderFns } from "./CategoriesBtn.vue?vue&type=template&id=40fb2751"
import script from "./CategoriesBtn.vue?vue&type=script&lang=js"
export * from "./CategoriesBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports